import {
  IonButton, IonCol, IonGrid, IonImg, IonLabel, IonRow, IonText, IonToggle,
} from '@ionic/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { EcommerceWidget, Widget, WidgetSection } from '@/interfaces/PluginInterface/PluginInterface';
import { WidgetFormWrapper } from './forms/WidgetFormWrapper';
import { WidgetCustomWrapper } from './forms/WidgetCustomWrapper';
import styles from './PluginConfig.module.scss';
import PluginFormWrapper from './forms/PluginFormWrapper';
import stylesPlugin from '../Plugin.module.scss';

interface PluginConfigProps {
  widgetData: EcommerceWidget | undefined;
  updateWidgetData: (arg0: any) => void;
}

export default function PluginConfig({ widgetData, updateWidgetData }: PluginConfigProps) {
  const [productWidget, setProductWidget] = useState<WidgetSection>();
  const [catalogWidget, setCatalogWidget] = useState<WidgetSection>();
  const [checkoutWidget, setCheckoutWidget] = useState<WidgetSection>();
  const [customWidget, setCustomWidget] = useState<WidgetSection>();

  const [productWidgetSTD, setProductWidgetSTD] = useState<Widget>();
  const [productWidgetDVN, setProductWidgetDVN] = useState<Widget>();
  const [catalogWidgetSTD, setCatalogWidgetSTD] = useState<Widget>();
  const [checkoutWidgetSTD, setCheckoutWidgetSTD] = useState<Widget>();
  const [checkoutWidgetDVN, setCheckoutWidgetDVN] = useState<Widget>();
  // custom
  const [customWidgetSTD, setCustomWidgetSTD] = useState<Widget>();

  const [dataChanged, setDataChanged] = useState<boolean>(false);

  const sectionsUpdated = {
    product: false,
    catalog: false,
    checkout: false,
    custom: false,
  };

  const publish = (/* validationInput: boolean */) => {

    if (productWidget) {
      //modificar color de widget STD
      if (productWidgetSTD) {

        updateValue({ name: 'background_color', value: customWidgetSTD?.background_color }, 'product', 'STD');
        updateValue({ name: 'buttons_color', value: customWidgetSTD?.buttons_color }, 'product', 'STD');
        updateValue({ name: 'background_buttons_color', value: 'light' }, 'product', 'STD');
      } else {
      }
      //modificar color de widget DVN
      if (productWidgetDVN) {
        updateValue({ name: 'background_color', value: customWidgetSTD?.background_color }, 'product', 'DVN');
        updateValue({ name: 'buttons_color', value: customWidgetSTD?.buttons_color }, 'product', 'DVN');
        updateValue({ name: 'background_buttons_color', value: 'light' }, 'product', 'DVN');
      } else {
      }
    } else {
    }
    if (checkoutWidget) {
      //modificar color de widget STD
      if (checkoutWidgetSTD) {
        updateValue({ name: 'background_color', value: customWidgetSTD?.background_color }, 'checkout', 'STD');
        updateValue({ name: 'buttons_color', value: customWidgetSTD?.buttons_color }, 'checkout', 'STD');
        updateValue({ name: 'background_buttons_color', value: 'light' }, 'checkout', 'STD');
      }
      //modificar color de widget DVN
      if (checkoutWidgetDVN) {
        updateValue({ name: 'background_color', value: customWidgetSTD?.background_color }, 'checkout', 'DVN');
        updateValue({ name: 'buttons_color', value: customWidgetSTD?.buttons_color }, 'checkout', 'DVN');
        updateValue({ name: 'background_buttons_color', value: 'light' }, 'checkout', 'DVN');
      }
    }

    const newData = {
      sections: [catalogWidget, productWidget, checkoutWidget],
    };

    updateWidgetData(newData);
    setDataChanged(false);

  };
  const checkToggle = (newValue: boolean, section: string, widgetType?: string) => {
    const obj = {
      name: 'enabled',
      value: newValue,
    };
    updateValue(obj, section, widgetType);
  };

  const updateValue = (e: any, section: string, widgetType?: string) => {
    setDataChanged(true);
    const { name, value } = e;
    if (section === 'product' && productWidget) {
      if (widgetType) {
        const widgetsUpdated = storeWidget({ name, value }, widgetType, productWidget);
        setProductWidget((prevState: any) => ({ ...prevState, widgets: [...widgetsUpdated] }));
        widgetType === 'DVN'
          ? setProductWidgetDVN(findWidget(widgetsUpdated, widgetType)) : setProductWidgetSTD(findWidget(widgetsUpdated, widgetType));
      } else {
        setProductWidget((prevState: any) => ({ ...prevState, [name]: value }));
      }
      sectionsUpdated.product = true;
    } else if (section === 'catalog' && catalogWidget) {
      if (widgetType) {
        const widgetsUpdated = storeWidget({ name, value }, widgetType, catalogWidget);
        setCatalogWidget((prevState: any) => ({ ...prevState, widgets: [...widgetsUpdated] }));
        setCatalogWidgetSTD(findWidget(widgetsUpdated, widgetType));
      } else {
        setCatalogWidget((prevState: any) => ({ ...prevState, [name]: value }));
      }
      sectionsUpdated.catalog = true;
    } else if (section === 'checkout' && checkoutWidget) {
      if (widgetType) {
        const widgetsUpdated = storeWidget({ name, value }, widgetType, checkoutWidget);
        setCheckoutWidget((prevState: any) => ({ ...prevState, widgets: [...widgetsUpdated] }));
        widgetType === 'DVN'
          ? setCheckoutWidgetDVN(findWidget(widgetsUpdated, widgetType))
          : setCheckoutWidgetSTD(findWidget(widgetsUpdated, widgetType));
      } else {
        setCheckoutWidget((prevState: any) => ({ ...prevState, [name]: value }));
      }
      sectionsUpdated.checkout = true;
      //si es la section custom y tiene widgetType
    } else if (section === 'custom' && customWidget) {
      //actualizar el widget STD
      if (widgetType) {
        const widgetsUpdated = storeWidget({ name, value }, widgetType, customWidget);
        setCustomWidget((prevState: any) => ({ ...prevState, widgets: [...widgetsUpdated] }));
        setCustomWidgetSTD(findWidget(widgetsUpdated, widgetType));
      } else {

        setCustomWidget((prevState: any) => ({ ...prevState, [name]: value }));
      }
      sectionsUpdated.custom = true;
    }
  };

  const storeWidget = (inputChange: any, widgetType: string, originalData: WidgetSection) => {
    const { name, value } = inputChange;
    const updated = originalData;
    const widgetSelected = updated?.widgets.findIndex((item: any) => item.type === widgetType)!;
    updated.widgets[widgetSelected][name as keyof Widget] = value;
    return updated.widgets;
  };

  const filterPluginSections = () => {
    if (widgetData) {
      widgetData.sections.map((pageSection: WidgetSection) => {
        if (pageSection.section === 'product') {
          setProductWidget(pageSection);
          if (pageSection.enabled) {
            pageSection.widgets.map((widgetSelected: Widget) => {
              if (widgetSelected.type === 'STD') {
                setProductWidgetSTD(widgetSelected);
              } else if (widgetSelected.type === 'DVN') {
                setProductWidgetDVN(widgetSelected);
              }
            });
          }
        } else if (pageSection.section === 'catalog') {
          setCatalogWidget(pageSection);
          if (pageSection.enabled) {
            pageSection.widgets.map((widgetSelected: Widget) => {
              if (widgetSelected.type === 'STD') {
                setCatalogWidgetSTD(widgetSelected);
              }
            });
          }
        } else if (pageSection.section === 'checkout') {
          //si el campo dom_qty no existe, se crea con valor 0
          if (!pageSection.dom_qty) {
            pageSection.dom_qty = '0';
          }
          setCheckoutWidget(pageSection);
          // setAllCheckoutToggle(pageSection.enabled);
          if (pageSection.enabled) {
            pageSection.widgets.map((widgetSelected: Widget) => {
              if (widgetSelected.type === 'STD') {
                setCheckoutWidgetSTD(widgetSelected);
              } else if (widgetSelected.type === 'DVN') {
                setCheckoutWidgetDVN(widgetSelected);
              }
            });
          }
        }
      });
    }
    // custom
    sectionCustomWidget();

  };


  const sectionCustomWidget = () => {
    let sectionWidget: Widget | null = null;
    //comprobar que no existe custom
    if (widgetData?.sections) {
      const customSection = widgetData.sections.find((section: WidgetSection) => section.section === 'custom');
      if (customSection) {
        return;
      }
    }
    if (widgetData) {
      widgetData.sections.forEach((pageSection: WidgetSection) => {
        if (pageSection.section === 'product') {
          pageSection.widgets.forEach((widgetSelected: Widget) => {
            if (widgetSelected.type === 'STD') {
              setCustomWidgetSTD(widgetSelected);
              sectionWidget = widgetSelected; // Asigna el widget seleccionado
            }
          });
        }
      });

      widgetData.sections.push({
        section_id: 'custom',
        section: 'custom',
        dom: widgetData?.sections[0].dom,
        dom_var_price: widgetData?.sections[0].dom_var_price,
        dom_page_identification: widgetData?.sections[0].dom_page_identification,
        enabled: true,
        widgets: sectionWidget ? [sectionWidget] : [],
      });

      widgetData.sections.map((pageSection: WidgetSection) => {
        if (pageSection.section === 'custom') {
          setCustomWidget(pageSection);
        }
      });
    }
  };
  const findWidget = (widgetsList: Widget[] | undefined, widgetType: string) => {
    if (widgetsList) {
      return widgetsList.find((item: any) => item.type === widgetType);
    }
  };

  useEffect(() => {
    if (widgetData) {
      filterPluginSections();
    }
  }, [widgetData]);

  return (
    <div className={styles.pluginConfigWrapper}>
      <div className={stylesPlugin.pluginHeaderWrapper}>
        <div className={stylesPlugin.pluginTitleWrapper}>
          <IonText className={stylesPlugin.titleText}>Configuración de plugin</IonText>
        </div>
        <IonButton
          className={stylesPlugin.publishBtn}
          onClick={publish}
          disabled={!dataChanged}
        >
          Publicar
        </IonButton>
      </div>
      <hr className={stylesPlugin.separationLine} />
      <div className={styles.pluginSectionWrapper} id="plugin-product-section">
        <IonGrid>
          <IonRow className={styles.pluginTitleRow}>
            <IonCol>
              <IonText className={styles.sectionTitle}>Página de producto</IonText>
            </IonCol>
            <IonCol>
              <div className={classNames(styles.pluginToggleWrapper, styles.generalToggle)}>
                <IonToggle
                  value="product"
                  //color= "danger"
                  checked={productWidget?.enabled}
                  onIonChange={(e) => checkToggle(e.detail.checked, 'product')}
                />
                <div className={classNames(styles.pluginToggleLabel, productWidget?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                  {productWidget?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
        {productWidget?.enabled && (
          <>
            <PluginFormWrapper
              formData={productWidget}
              handleInputUpdate={(e: any) => {
                updateValue(e.target, 'product');
              }}
            />
            <IonGrid>
              <IonRow className={styles.pluginFormWidgetRow}>
                <IonCol className={classNames(styles.widgetSection, productWidgetSTD?.enabled ? styles.widgetSectionStdEnabled : styles.widgetSectionStd)} size="12" size-md="5.75">
                  <IonRow className={styles.widgetSectionHeader}>
                    <IonText className={styles.widgetSectionTitle}>Widget Estándar</IonText>
                    <div className={classNames(styles.pluginToggleWrapper, styles.widgetToggle)}>
                      <IonToggle
                        value="product-std"
                        checked={productWidgetSTD?.enabled}
                        className={classNames(productWidgetSTD?.enabled ? 'toggleChecked' : 'toggleUnchecked')}
                        onIonChange={(e) => checkToggle(e.detail.checked, 'product', 'STD')}
                      />
                      <div className={classNames(styles.pluginToggleLabel, productWidgetSTD?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                        {productWidgetSTD?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                      </div>
                    </div>
                  </IonRow>
                  <WidgetFormWrapper
                    formData={productWidget}
                    productWidgetDVN={productWidgetSTD?.enabled}
                    widgetType={productWidget?.widgets?.find((widget: Widget) => widget.type === 'STD')}
                    handleInputUpdate={(e: any) => updateValue(e.target, 'product', 'STD')}
                  />
                </IonCol >
                <IonCol size="0" size-md="0.5" />
                <IonCol className={classNames(styles.widgetSection, productWidgetDVN?.enabled ? styles.widgetSectionStdEnabled : styles.widgetSectionStd)}
                  size="12" size-md="5.75">
                  <IonRow className={styles.widgetSectionHeader}>
                    <IonText className={styles.widgetSectionTitleDvn}>Widget Divide en N</IonText>
                    <IonText className={classNames(styles.widgetSectionTitleDvn, styles.widgetSectionTitleDvnXs)}>Widget DVN</IonText>
                    <div className={classNames(styles.pluginToggleWrapper, styles.widgetToggle)}>
                      <IonToggle
                        value="product-dvn"
                        checked={productWidgetDVN?.enabled}
                        onIonChange={(e) => checkToggle(e.detail.checked, 'product', 'DVN')}
                      />
                      <div className={classNames(styles.pluginToggleLabel, productWidgetDVN?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                        {productWidgetDVN?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                      </div>
                    </div>
                  </IonRow>
                  <WidgetFormWrapper
                    formData={productWidget}
                    productWidgetDVN={productWidgetDVN?.enabled}
                    widgetType={productWidget?.widgets?.find((widget: Widget) => widget.type === 'DVN')}
                    handleInputUpdate={(e: any) => updateValue(e.target, 'product', 'DVN')}
                  />
                </IonCol>
              </IonRow >
            </IonGrid >
          </>
        )}
        <hr className={stylesPlugin.separationLine} />
      </div>
      <div className={styles.pluginSectionWrapper} id="plugin-catalog-section">
        <IonRow className={styles.pluginTitleRow}>
          <IonCol>
            <IonText className={styles.sectionTitle}>Listados</IonText>
          </IonCol>
          <IonCol>
            <div className={classNames(styles.pluginToggleWrapper, styles.generalToggle)}>
              <IonToggle
                value="catalog"
                checked={catalogWidget?.enabled}
                onIonChange={(e) => checkToggle(e.detail.checked, 'catalog')}
              />
              <div className={classNames(styles.pluginToggleLabel, catalogWidget?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                {catalogWidget?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
              </div>
            </div>
          </IonCol>
        </IonRow>
        {catalogWidget?.enabled && (
          <>
            <PluginFormWrapper
              formData={catalogWidget}
              handleInputUpdate={(e: any) => updateValue(e.target, 'catalog')}
            />
            <IonRow className={styles.pluginFormWidgetRow}>
              <IonCol className={classNames(styles.widgetSection, catalogWidgetSTD?.enabled ? styles.widgetSectionStdEnabled : styles.widgetSectionStd)}>
                <IonRow className={styles.widgetSectionHeader}>
                  <IonText className={styles.widgetSectionTitle}>Widget Estándar</IonText>
                  <div className={classNames(styles.pluginToggleWrapper, styles.widgetToggle)}>
                    <IonToggle
                      value="catalog-std"
                      checked={catalogWidgetSTD?.enabled}
                      onIonChange={(e) => checkToggle(e.detail.checked, 'catalog', 'STD')}
                    />
                    <div className={classNames(styles.pluginToggleLabel, catalogWidgetSTD?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                      {catalogWidgetSTD?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                    </div>
                  </div>
                </IonRow>
                <WidgetFormWrapper
                  formData={catalogWidget}
                  productWidgetDVN={catalogWidgetSTD?.enabled}
                  widgetType={catalogWidget?.widgets?.find((widget: Widget) => widget.type === 'STD')}
                  handleInputUpdate={(e: any) => updateValue(e.target, 'catalog', 'STD')}
                />
              </IonCol>
            </IonRow>
          </>
        )}
        <hr className={stylesPlugin.separationLine} />
      </div>
      <div className={styles.pluginSectionWrapper} id="checkout-product-section">
        <IonRow className={styles.pluginTitleRow}>
          <IonCol>
            <IonText className={styles.sectionTitle}>Checkout</IonText>
          </IonCol>
          <IonCol>
            <div className={classNames(styles.pluginToggleWrapper, styles.generalToggle)}>
              <IonToggle
                value="checkout"
                checked={checkoutWidget?.enabled}
                onIonChange={(e) => checkToggle(e.detail.checked, 'checkout')}
              />
              <div className={classNames(styles.pluginToggleLabel, checkoutWidget?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                {checkoutWidget?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
              </div>
            </div>
          </IonCol>
        </IonRow>
        {checkoutWidget?.enabled && (
          <>
            <PluginFormWrapper
              formData={checkoutWidget}
              handleInputUpdate={(e: any) => updateValue(e.target, 'checkout')} />
            <IonGrid>
              <IonRow className={styles.pluginFormWidgetRow}>
                <IonCol className={classNames(styles.widgetSection, checkoutWidgetSTD?.enabled ? styles.widgetSectionStdEnabled : styles.widgetSectionStd)}
                  size="12" size-md="5.75">
                  <IonRow className={styles.widgetSectionHeader}>
                    <IonText className={styles.widgetSectionTitle}>Widget Estándar</IonText>
                    <div className={classNames(styles.pluginToggleWrapper, styles.widgetToggle)}>
                      <IonToggle
                        value="checkout-std"
                        checked={checkoutWidgetSTD?.enabled}
                        onIonChange={(e) => checkToggle(e.detail.checked, 'checkout', 'STD')}
                      />
                      <div className={classNames(styles.pluginToggleLabel, checkoutWidgetSTD?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                        {checkoutWidgetSTD?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                      </div>
                    </div>
                  </IonRow>
                  <WidgetFormWrapper
                    formData={checkoutWidget}
                    productWidgetDVN={checkoutWidgetSTD?.enabled}
                    widgetType={checkoutWidget?.widgets?.find((widget: Widget) => widget.type === 'STD')}
                    handleInputUpdate={(e: any) => updateValue(e.target, 'checkout', 'STD')}
                  />
                </IonCol>
                <IonCol size="0" size-md="0.5" />
                <IonCol className={classNames(styles.widgetSection, checkoutWidgetDVN?.enabled ? styles.widgetSectionStdEnabled : styles.widgetSectionStd)}
                  size="12" size-md="5.75">
                  <IonRow className={styles.widgetSectionHeader}>
                    <IonText className={styles.widgetSectionTitleDvn}>Widget Divide en N</IonText>
                    <IonText className={classNames(styles.widgetSectionTitleDvn, styles.widgetSectionTitleDvnXs)}>Widget DVN</IonText>
                    <div className={classNames(styles.pluginToggleWrapper, styles.widgetToggle)}>
                      <IonToggle
                        value="checkout-dvn"
                        checked={checkoutWidgetDVN?.enabled}
                        onIonChange={(e) => checkToggle(e.detail.checked, 'checkout', 'DVN')}
                      />
                      <div className={classNames(styles.pluginToggleLabel, checkoutWidgetDVN?.enabled ? styles.pluginSwitchOn : styles.pluginSwitchOff)}>
                        {checkoutWidgetDVN?.enabled ? 'ACTIVADO' : 'DESACTIVADO'}
                      </div>
                    </div>
                  </IonRow>
                  <WidgetFormWrapper
                    formData={checkoutWidget}
                    productWidgetDVN={checkoutWidgetDVN?.enabled}
                    widgetType={checkoutWidget?.widgets?.find((widget: Widget) => widget.type === 'DVN')}
                    handleInputUpdate={(e: any) => updateValue(e.target, 'checkout', 'DVN')}
                  />
                </IonCol>
              </IonRow>
            </IonGrid>
          </>
        )}
        <hr className={stylesPlugin.separationLine} />
      </div>
      <div
        className={classNames(styles.pluginSectionWrapper)}
        id="plugin-catalog-section">
        <IonRow
          className={classNames(styles.pluginTitleRow)}>
          <IonCol>
            <IonText className={classNames(styles.sectionTitle)}>
              Personalizar modelo de widget</IonText>
          </IonCol>

        </IonRow>
        <>
          <IonRow
            className={classNames(styles.pluginFormWidgetRow)}>
            <IonCol
              className={classNames(styles.widgetSection, styles.widgetSectionStd)}>
              <WidgetCustomWrapper
                formData={customWidget}
                widgetType={customWidget?.widgets?.find((widget: Widget) => widget.type === 'STD')}
                handleInputUpdate={(e: any) => updateValue(e.target, 'custom', 'STD')}
              />
            </IonCol>
          </IonRow>
        </>
      </div>
    </div >
  );
}
